import { render, staticRenderFns } from "./GExamCreate.vue?vue&type=template&id=3ca3c6ee&scoped=true&"
import script from "./GExamCreate.vue?vue&type=script&lang=ts&"
export * from "./GExamCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca3c6ee",
  null
  
)

export default component.exports